<template>
    <input
        :disabled="disabled"
        :class="inputClasses"
        :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" ref="input">
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
    props: {
        modelValue: String,
        error : {
            type: Boolean,
            default: false,
        },
        disabled: Boolean,
    },

    emits: ['update:modelValue'],

    computed: {
        inputClasses() {
            return this.error ? "mt-1 text-sm border-red-600 dark:text-gray-300 dark:bg-gray-700 focus:border-red-400 focus:outline-none focus:shadow-outline-red form-input"
                : "mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-red-400 dark:focus:border-gray-600 focus:outline-none focus:shadow-outline-red dark:text-gray-300 dark:focus:shadow-outline-gray form-input";
        }
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
    }
})
</script>
